import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, config, MemberQuery, WebPushNotificationService } from '@fgb/core';
import { Router, NavigationEnd } from '@angular/router';
declare var gtag: any;
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { buildContentAssetUrl } from './shared/utils/content-asset-url.util';

@Component({
  selector: 'fgb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  constructor(
    public authService: AuthService,
    private router: Router,
    private webPushNotificationService: WebPushNotificationService,
    private memberQuery: MemberQuery
  ) {
    if (config.googleAnalyticsTag !== '') {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + config.googleAnalyticsTag;
      document.head.prepend(script);
    }
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://paytechtrust.transactiongateway.com/token/Collect.js';
    script1.setAttribute('data-tokenization-key', 'p3xSS4-Kan4r4-82Yp6C-9E6nuv');
    document.head.prepend(script1);

    const navigationEvent = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      takeUntil(this._destroyed$)
    );
    if (config.googleAnalyticsTag !== '') {
      navigationEvent.subscribe((e) => {
        let event = e as NavigationEnd;
        gtag('config', config.googleAnalyticsTag, { page_path: event.urlAfterRedirects });
      });
    }
    /** Google maps API */
    if (config.googleMapsAPIKey !== '') {
      const googleMapsScript = document.createElement('script');
      googleMapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + config.googleMapsAPIKey;
      document.head.prepend(googleMapsScript);
    }

    this.webPushNotificationService.subscribe();
  }

  ngOnInit(): void {
    this.setContentAssetBackgroundImages();
  }

  /**
   * Global/shared CSS background-image rules (e.g. .banner, .login-banner) live in stylesheets
   * that can't run Angular pipes, so the resolved ContentAssets URLs are exposed as CSS custom
   * properties here instead and referenced via var(--x) in those stylesheets.
   */
  private setContentAssetBackgroundImages(): void {
    const cssVars: { [property: string]: string } = {
      '--bg-banner-mobile': 'banners/mobile.jpg',
      '--bg-banner-desktop': 'banners/desktop.jpg',
      '--bg-exclusive-offers-desktop': 'savings/DesktopSavings.jpg',
      '--bg-exclusive-offers-mobile': 'savings/MobileSavings.jpg',
      '--bg-login-banner': 'games/pagebackgroundgame.jpg',
      '--bg-home-member-card': 'member-card.png',
      '--bg-oauth-login-banner': 'login-registration/login-image-2025.jpg',
    };

    Object.keys(cssVars).forEach((property) => {
      const url = buildContentAssetUrl(this.memberQuery, cssVars[property]);
      document.documentElement.style.setProperty(property, `url(${url})`);
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
